import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import Promise from 'bluebird';

// Services
import Agreement from 'services/data/agreement';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import { AjaxSelectInput } from 'components/forms/form-elements';

// Constants
import { SELECT_PAGE_SIZE, SHORT_HUMAN_DATE_FORMAT } from 'constants';


class AgreementSelect extends React.Component {
  static propTypes = {
    company: PropTypes.number,
    companies: PropTypes.array,
    searchParams: PropTypes.object,
    input: PropTypes.object,
    onChangeFullValue: PropTypes.func,
    setDefaultAgreement: PropTypes.bool,
    multi: PropTypes.bool
  };

  static defaultProps = {
    searchParams: {},
    setDefaultAgreement: true
  };

  constructor() {
    super();

    this.state = {};
    this.getData = this.getData.bind(this);
    this.setAgreement = this.setAgreement.bind(this);
  }

  componentDidMount() {
    if (this.props.company && !this.props.input.value) this.setAgreement();
  }

  setAgreement() {
    const { company, companies, setDefaultAgreement, multi } = this.props;
    const companyObject = _.find(companies, { id: company });
    const defaultAgreement = _.get(companyObject, 'defaultAgreement');

    if (!defaultAgreement || !setDefaultAgreement) return;

    return Agreement.findOne(defaultAgreement)
      .then(agreement => {
        this.props.input.onChange(multi ? [defaultAgreement] : defaultAgreement);
        if (this.props.onChangeFullValue) this.props.onChangeFullValue(multi ? [agreement] : agreement);
      });
  }

  getData(term, vals) {
    if (!this.props.company) return;
    const ids = _.compact(_.concat([], vals));
    
    const defaultParams = {
      where: { company: this.props.company },
      sort: 'title',
      limit: SELECT_PAGE_SIZE
    };

    const params = _.defaultsDeep({}, this.props.searchParams, defaultParams);

    if (term) params.where.title = { contains: term };

    return Promise.all([
      Agreement.find(params),
      ids && ids.length ? Agreement.find({ where: { id: { in: ids } } }) : []
    ])
      .then(([search, values]) => _.unionBy(search, values, 'id'))
      .then((agreements) => _.orderBy(agreements, ['endDate'], ['desc']))
      .catch(alerts.catchError);
  }

  renderAgreementOption(agreement) {
    const isInactive = Agreement.isInactive(agreement);
    const formattedEndDate = moment(agreement.endDate).format(SHORT_HUMAN_DATE_FORMAT);
    
    return (
      <span>
        {agreement.title} {isInactive ? <span className="deemphasize">({formattedEndDate})</span> : ''}
      </span>
    );
  }

  render() {
    const { company } = this.props;

    return (
      <AjaxSelectInput
        {..._.omit(this.props, ['company', 'searchParams'])}
        labelKey="title"
        valueKey="id"
        noResultsText={company ? 'No active agreements' : 'Select a company'}
        triggerUpdate={company}
        onTriggerUpdate={this.setAgreement}
        loadOptions={this.getData}
        optionRenderer={this.renderAgreementOption}
      />
    );
  }
}

export default connect((state) => ({
  companies: state.pageData.selectCompanies
}))(AgreementSelect);
